$( document ).ready(function() {    
var mq = window.matchMedia( "(max-width: 990px)" )
if (mq.matches) {
    // window width is at less than 768px
 $('#cat-tree').hide()
//    $('.page-head').show()
//    $('.page-head').css('padding','0')

}

var mq = window.matchMedia( "(min-width: 991px)" )
if (mq.matches) {
    // window width is at morethan 768px
    $('#cat-tree').show()
 //   $('.page-head').hide()

}

$('.fashion-accessories').click(function(e) {
window.open('http://cococarmen.com/pages/sms', '_blank');
});

})



$( window ).resize(function() {
var mq = window.matchMedia( "(max-width: 990px)" )
if (mq.matches) {
    // window width is at less than 768px
    $('#cat-tree').hide()
//    $('.page-head').show()
//    $('.page-head').css('padding','0')

}

var mq = window.matchMedia( "(min-width: 991px)" )
if (mq.matches) {
    // window width is at morethan 768px
    $('#cat-tree').show()
//    $('.page-head').hide()

}
})